import React from "react";
import {
  Box,
  Typography,
  Divider,
  Grid,
} from "@mui/material";
import { useFormikContext } from "formik";
import { GenericTextField } from "../../../components/common/FormFields";
import GenericDateField from "../../../components/common/FormFields/GenericDateField";
import GenericMonthDayField from "../../../components/common/FormFields/GenericMonthDayField";
import { EmployeeProfileFormValues } from "../validation/employeeProfileValidation";

const EmployeeProfileFormContent: React.FC = () => {
  const formik = useFormikContext<EmployeeProfileFormValues>();

  return (
    <Box>
      <Grid container spacing={3}>
        {/* Personal Information Section */}
        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
            Personal Information
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericDateField
            name="dateOfBirth"
            label="Date of Birth"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericMonthDayField
            name="familyHoliday"
            label="Family Holiday"
            tooltip="Slava day"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericTextField
            name="phoneNumber"
            label="Phone number"
            placeholder="Your mobile or direct work phone"
          />
        </Grid>

        {/* Address Section */}
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
            Address Information
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <GenericTextField
            name="street"
            label="Street Address"
            placeholder="Enter your street address"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericTextField
            name="city"
            label="City"
            placeholder="Enter your city"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericTextField
            name="state"
            label="State/Province"
            placeholder="Enter your state or province"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericTextField
            name="zipCode"
            label="Zip/Postal Code"
            placeholder="Enter your zip or postal code"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericTextField
            name="country"
            label="Country"
            placeholder="Enter your country"
          />
        </Grid>

        {/* Emergency Contact Section */}
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
            Emergency Contact Information
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericTextField
            name="emergencyContactName"
            label="Emergency Contact Name"
            placeholder="Enter emergency contact name"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <GenericTextField
            name="emergencyContactPhone"
            label="Emergency Contact Phone"
            placeholder="Enter emergency contact phone number"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmployeeProfileFormContent;
